<div class="content">
  <div class="content-panel-overflow">
    <!-- Filtre Nature -->
    <form [formGroup]="formInitialGroup" #form="ngForm">
      <div class="mb-3">
        <label class="form-label" for="nature" translate>page.operateurs.controles.nature</label> :
        <select id="nature" formControlName="nature" class="form-select other-input" (change)="onChangeNature()"
                [ngClass]="{'is-invalid': form.submitted && nature.invalid}">
          <option [ngValue]="null" selected hidden></option>
          <option *ngFor="let nature of refNatures" [ngValue]="nature.id">{{ nature.libelle }}</option>
        </select>
      </div>
    </form>

    <div *ngIf="nature.value && controles?.length > 0">
      <!-- Title -->
      <h2 translate>page.operateurs.controles.title</h2>

      <!-- Filtres -->
      <form [formGroup]="formFilterGroup" #formFilter="ngForm" (ngSubmit)="onFilter()" class="d-flex align-items-center mb-3">
        <div class="d-flex align-items-center">
          <!-- Année de controle -->
          <div class="mb-3">
            <label class="form-label" for="anneeControle" translate>page.operateurs.controles.anneeControle</label>
            <input id="anneeControle" formControlName="anneeControle" maxlength="4"
                   [ngClass]="{ 'is-invalid': anneeControle.dirty && anneeControle.invalid }" class="form-control annee-input" />
          </div>
          <!-- Cahier des charges -->
          <div class="mb-3 d-flex align-items-center">
            <label for="cdc" translate>page.operateurs.controles.cdc</label>
            <app-multiselect id="cdc" controlName="cdc" [items]="cahiers" bindLabel="libelle" maxWidth="initial" class="ms-3"></app-multiselect>
          </div>
          <!-- Bouton -->
          <button type="submit" class="btn btn-primary button-filter mb-3" translate>label.filtrer</button>
        </div>
      </form>

      <!-- Tableau -->
      <table class="table" aria-label="Tableau des controles">
        <thead>
          <th *ngFor="let column of columns" [class.text-end]="column.field === 'volume'">
            <span translate>{{ column.label }}</span>
          </th>
        </thead>
        <tbody>
          <tr *ngFor="let controle of displayedControles">
            <td *ngFor="let column of columns" class="column-max-width" [class.text-end]="column.field === 'volume'">
              <ng-container [ngSwitch]="column.field">
                <!-- Date du contrôle -->
                <span *ngSwitchCase="'dateControle'">{{ controle?.dateControle | date:'dd/MM/yyyy' }}</span>
                <!-- Produit -->
                <span *ngSwitchCase="'produit'">{{ controle?.libelleProduit }}</span>
                <!-- Millésime -->
                <span *ngSwitchCase="'millesime'">{{ controle?.millesime }}</span>
                <!-- Logt / N° lot -->
                <span *ngSwitchCase="'logtLot'">
                  <ng-container *ngIf="controle?.logement || controle?.numeroLot">
                    {{ controle?.logement }} / {{ controle?.numeroLot }}
                  </ng-container>
                </span>
                <!-- Volume -->
                <span *ngSwitchCase="'volume'">{{ controle?.volume | number: '1.2-2' }}</span>
                <!-- Type de lot -->
                <span *ngSwitchCase="'typeMouvement'">{{ controle?.libelleMouvement }}</span>
                <!-- Expertise / N° passage -->
                <span *ngSwitchCase="'expertisePassage'">{{ controle?.numeroExpertise }} / {{ controle?.numeroPassage }}</span>
                <!-- Résultats -->
                <span *ngSwitchCase="'resultat'">{{ controle?.nbManquement }} manquement(s)</span>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="nature.value && controles?.length === 0" class="alert alert-warning alert-block" translate>
      <fa-icon icon="exclamation"></fa-icon>
      page.controles.controles.search.aucunControle
    </div>
  </div>
</div>

